<template>
    <div>
        <component
            :is="documentType"
        />

    </div>
</template>

<script>
import OutgoingDocumentCommon from './CommonOutgoingCard.vue';
import IncomingDocument from './IncomingCard.vue';
import InnerDocument from './InnerCard.vue';
import NPADocument from './NPADocumentCard.vue';
import OutgoingDocument from './OutgoingCard.vue';
import Resolution from '@/views/global/cards/Resolution.vue';
import ActItem from '@/views/global/cards/ActItem.vue'


export default {
    name: "DocumentCardProxy",
    components: {
        OutgoingDocumentCommon,
        IncomingDocument,
        InnerDocument,
        OutgoingDocument,
        NPADocument,
        Resolution,
        ActItem
    },
    computed: {
        documentType(){
            return this.$store.getters['global/actionsource/getDataSourceType'];
        }
    }
}

</script>